import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    getSubscriptionActive,
    mySubscriptionProducts,
} from "@TKCCP/Services/tkccpSubscriptionProductsService";
import { CustomApiHandler } from "@TKCCP/Store/CustomHandlerCreator/CustomHandlerCreator";

type Props = {
    CustomerId: string;
    UserProfileId: string;
};

type HandlerType = CustomApiHandler<mySubscriptionProducts, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getSubscriptionActive(props.apiParameter);
};

export const DispatchCompleteLoadSubscriptionProduct: HandlerType = props => {
    props.dispatch({
        type: "Data/SubsriptionProductService/getSubscriptionActive",
        collection: props.apiResult,
    });
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadSubscriptionProduct,
];

const getSubscriptionActiveData = createHandlerChainRunner(chain, "getSubscriptionActiv");
export default getSubscriptionActiveData;